import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isSubmitting } from 'redux-form';
import IOSLoader from '../../../shared/components/IOSLoader/IOSLoader';

import containerWidth from '../../../shared/helpers/containerWidth';

import './BottomNavigation.scss';
import EstimatePrice from '../EstimatePrice/EstimatePrice';

const BottomNavigation = ({
  goBack,
  btnBackTxt,
  goForward,
  btnFwdText,
  submitting,
}) => (
  <div className="row bottom_navigation mt-5">
    <div className={`${containerWidth} text-right align-self-center`}>
      <div className="row align-items-center">
        <EstimatePrice />
        <div className="col-auto" />
        <div className="col">
          <button
            type="button"
            disabled={submitting}
            className="btn btn-outline-dark mr-4 bottom_navigation__back_btn"
            onClick={goBack}
          >
            {btnBackTxt}
          </button>
          <button
            type="button"
            disabled={submitting}
            className="btn btn-success bottom_navigation__continue_btn"
            onClick={goForward}
          >
            {submitting ? (
              <div className="bottom_navigation__loading">
                <IOSLoader />
              </div>
            ) : (
              btnFwdText
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
);

BottomNavigation.propTypes = {
  goBack: PropTypes.func,
  btnBackTxt: PropTypes.string,
  goForward: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  btnFwdText: PropTypes.any,
  submitting: PropTypes.bool.isRequired,
};
BottomNavigation.defaultProps = {
  goBack: null,
  btnBackTxt: 'Back',
  goForward: null,
  btnFwdText: 'Forward',
};

export default connect((state) => ({
  submitting: isSubmitting('WizardOrderForm')(state),
}))(BottomNavigation);
